/** @jsxImportSource theme-ui */
import React from 'react';

import BdPngExportHeader from 'components/_controls/PngExports/BdPngExportHeader';

import RiskOverviewCardContent from 'riskOverview/containers/RiskOverviewCardContent';

import RiskOverviewCardLandscapeContainer from './RiskOverviewCardLandscapeContainer';

type RiskOverviewCardBasicLandscapeProps = {
  header: string;
  locationId: number;
  activityId: number;
};

const RiskOverviewCardBasicLandscape: React.FC<RiskOverviewCardBasicLandscapeProps> = ({
  header,
  locationId,
  activityId,
}) => {
  return (
    <RiskOverviewCardLandscapeContainer>
      <BdPngExportHeader title={header} superTitle="Your risk of" supertitleVariant="overline" />
      <RiskOverviewCardContent
        diseaseActivityId={activityId}
        locationId={locationId}
        sx={{ px: '0px !important' }}
      />
    </RiskOverviewCardLandscapeContainer>
  );
};

export default RiskOverviewCardBasicLandscape;
